import { HelpTooltip } from 'components/HelpTooltip'
import { banStatusStrings } from 'constants/strings'

type BanStatusLabelProps = {
  label: string
  help: keyof typeof banStatusStrings.help
  helpButtonClassName?: string
}

export function BanStatusLabel({ label, help, helpButtonClassName }: BanStatusLabelProps) {
  return (
    <span className="inline-flex max-w-full items-center gap-1 align-middle">
      <span className="min-w-0 whitespace-normal">{label}</span>
      <HelpTooltip
        label={`${label}${banStatusStrings.helpLabelSuffix}`}
        description={banStatusStrings.help[help]}
        className={helpButtonClassName}
      />
    </span>
  )
}
